import React from "react";
import Page, { PageProps } from "../Page";
import { Layout, Menu, Divider, Button, Icon, Typography, Tooltip } from "antd";
import { IFormDetailsPresenter } from "../../../presenter/form/FormDetailsPresenter";
import DisplayForm from "../../components/form/DisplayForm";
import ComapreVersionsDialog from "./CompareVersionsDialog";
import Loader from "../../components/Loader";
import ComparisonFormVersions from "./ComparisonFormVersions";
import { DateService } from "../../../service/DateService";
import Text from "antd/lib/typography/Text";

const { Sider } = Layout;

export interface Props extends PageProps {}
export interface State extends IFormDetailsPresenter {}

export default class FormDetailsPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      formVersionList,
      onSelectVersion,
      formSectionList,
      getReferenceValues,
      referenceValueList,
      isEditableForm,
      onChangeFormVersion,
      onCancel,
      addRow,
      sendFormVersion,
      selectedVersion,
      isDraftFormVersion,
      deleteRow,
      isPreviousForm,
      changeFormAttribute,
      validationErrors,
      firstValidatedAttribute,
      hideSendFormVersionDialog,
      showSendFormVersionDialog,
      sendFormModalVisible,
      formQualifierValidationErrors,
      hasRightOfEntry,
      deleteDraftFormVersion,
      comparisonVersionsModalVisible,
      onChangeComapreVersionsModal,
      onSelectCompareVersions,
      compareVersionsSelected,
      comparisonFormVersionsVisible,
      firstComparisonFormVersion,
      secondComparisonFormVersion,
      getComparisonFormVersionsDetails,
      onChangeComparisonFormVersionsVisible,
      pdfReportData,
      applicant,
      formVersion,
      pdfReportVisbile,
      generatePdfReport,
      formType,
      allowedFileTypes,
      reportingPeriodId,
      reportingPeriodFormTypeId,
      isSignedReportRequired,
      signedReportValidationError,
      resetSignedReportValidationError
    } = this.state;

    const {
      pdfReportLoader,
      sendFormVersionLoader,
      showSendFormVersionDialogLoader,
      changeFormAttributeLoader,
      onChangeFormLoader
    } = this.state.loaders;

    return (
      <Page {...this.props}>
        <Loader
          loading={onChangeFormLoader}
          tip={translate("form_details.new_draft_version_loading")}
          translate={translate}
          size="large"
        >
          <Layout className={"form-detals-report-container"}>
            {!comparisonFormVersionsVisible && (
              <Sider
                width={!comparisonFormVersionsVisible ? 200 : 80}
                className={"form-details-sider"}
              >
                <Button
                  type="primary"
                  style={{ width: "100%", marginBottom: 10 }}
                  onClick={() => onChangeComapreVersionsModal(true)}
                  disabled={formVersionList.length < 2}
                >
                  {translate("compare_versions.title")}
                </Button>
                <Typography.Title level={4} style={{ fontSize: 14 }}>
                  {translate("form_details.form_versions")}
                </Typography.Title>
                <Menu
                  mode="inline"
                  selectedKeys={
                    selectedVersion
                      ? [selectedVersion.id.toString()]
                      : undefined
                  }
                >
                  {formVersionList.map((item) => {
                    const isDigitallySigned = item.digitallySigned;
                    const signatureDate = item.signatureDate
                      ? DateService().formatDate(item.signatureDate)
                      : "";

                    return (
                      <Menu.Item
                        key={item.id}
                        onClick={(e) => {
                          onSelectVersion(item, true);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%"
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {isDigitallySigned ? (
                              <Tooltip
                                title={translate(
                                  "form_details.digital_signature_info",
                                  { date: signatureDate }
                                )}
                              >
                                <Icon
                                  type="safety-certificate"
                                  style={{
                                    marginRight: 8,
                                    color: "green",
                                    flexShrink: 0
                                  }}
                                />
                              </Tooltip>
                            ) : (
                              <span style={{ width: 22, flexShrink: 0 }} />
                            )}
                            <Text>
                              {item.version} - {item.status}
                              {item.sendDate && " | "}
                              {item.sendDate &&
                                DateService().formatDate(item.sendDate)}
                            </Text>
                          </div>
                        </div>
                      </Menu.Item>
                    );
                  })}
                </Menu>
              </Sider>
            )}
            {!comparisonFormVersionsVisible && (
              <Divider type={"vertical"} style={{ height: "initial" }} />
            )}
            {!comparisonFormVersionsVisible ? (
              <DisplayForm
                formSectionList={formSectionList}
                loading={this.state.loaders.formSectionLoader}
                translate={translate}
                getReferenceValues={getReferenceValues}
                referenceLoading={this.state.loaders.formReferenceLoader}
                referenceValueList={referenceValueList}
                isEditableForm={isEditableForm}
                onChangeFormVersion={onChangeFormVersion}
                onCancel={onCancel}
                addRow={addRow}
                sendFormVersion={sendFormVersion}
                selectedVersion={selectedVersion}
                isDraftFormVersion={isDraftFormVersion}
                deleteRow={deleteRow}
                isPreviousForm={isPreviousForm}
                onChangeFormLoading={onChangeFormLoader}
                changeFormAttribute={changeFormAttribute}
                validationErrors={validationErrors}
                firstValidatedAttribute={firstValidatedAttribute}
                className={"display-form-container"}
                hideSendFormVersionDialog={hideSendFormVersionDialog}
                showSendFormVersionDialog={showSendFormVersionDialog}
                sendFormModalVisible={sendFormModalVisible}
                formQualifierValidationErrors={formQualifierValidationErrors}
                hasRightOfEntry={hasRightOfEntry}
                deleteDraftFormVersion={deleteDraftFormVersion}
                formVersionList={formVersionList}
                pdfReportData={pdfReportData}
                pdfReportLoader={pdfReportLoader}
                applicant={applicant}
                formVersion={formVersion}
                pdfReportVisible={pdfReportVisbile}
                generatePdfReport={generatePdfReport}
                formType={formType}
                sendFormVersionLoader={sendFormVersionLoader}
                showSendFormVersionDialogLoader={
                  showSendFormVersionDialogLoader
                }
                changeFormAttributeLoader={changeFormAttributeLoader}
                allowedFileTypes={allowedFileTypes}
                reportingPeriodId={reportingPeriodId}
                reportingPeriodFormTypeId={reportingPeriodFormTypeId}
                isSignatureSectionVisible={true}
                isSignedReportRequired={isSignedReportRequired}
                signedReportValidationError={signedReportValidationError}
                onSignedReportFileSelected={resetSignedReportValidationError}
              />
            ) : (
              <Loader
                children={
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex", alignSelf: "flex-end" }}>
                      <Button
                        onClick={() =>
                          onChangeComparisonFormVersionsVisible(false)
                        }
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Icon type={"close"} style={{ lineHeight: 0 }} />
                      </Button>
                    </div>
                    <ComparisonFormVersions
                      translate={translate}
                      firstComparisonFormVersion={firstComparisonFormVersion}
                      secondComparisonFormVersion={secondComparisonFormVersion}
                      formVersionList={formVersionList}
                      selectedVersions={compareVersionsSelected || []}
                    />
                  </div>
                }
                translate={translate}
                loading={this.state.loaders.comparisonFormVersionsLoader}
              />
            )}

            <ComapreVersionsDialog
              visible={comparisonVersionsModalVisible}
              onChange={onChangeComapreVersionsModal}
              formVersionList={formVersionList}
              translate={translate}
              onSelectCompareVersions={onSelectCompareVersions}
              compareVersionsSelected={compareVersionsSelected}
              getComparisonFormVersionsDetails={
                getComparisonFormVersionsDetails
              }
              loading={this.state.loaders.comparisonFormVersionsLoader}
            />
          </Layout>
        </Loader>
      </Page>
    );
  }
}
